<div class="button-chip-section">
  <div class="button-chip-section__title">{{name}}</div>
  <div fxLayout="row wrap" fxLayoutAlign="start center">
    @for (chip of buttonChips; track chip.name) {
      <div [fxFlex]="chip.width" class="button-chip-section__chip-container">
        <button type="button" class="cfa-plain-button" [ngClass]="{'button-chip-section__chip-mobile' : isMobile, 'button-chip-section__chip' : !isMobile, 'button-chip-section__chip-selected' : chip.selected}"
          (click)="buttonChipToggled.emit(chip)"
          [attr.aria-pressed]="chip.selected">
          <div fxLayout="row" fxLayoutAlign="center center" [ngClass]="{'button-chip-section__subtext-chip' : chip.subtext}">
            <div class="button-chip-section__text"
              [attr.data-testid]="chip.name + '-button'"
              [ngClass]="{'button-chip-section__subtext-alignment' : chip.subtext}">
              {{chip.name}}
            </div>
            @if (chip.subtext) {
              <div class="button-chip-section__subtext">{{chip.subtext}}</div>
            }
          </div>
        </button>
      </div>
    }
  </div>
</div>
